import { useMemo } from 'react';
import classNames from 'classnames';
import { RequestsStatusesResponse } from '@Types/api/dashboardWidgets/RequestsStatuses';
import AwesomeSlider from 'react-awesome-slider';
// import ProjectMock from '@Images/mocks/projects-mock.png';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevrone-down.svg';
import { DoughnutChart } from '@Components/Base';
import commonStyle from '../../common-mobile-styles.module.css';
import styles from './component-styles.module.css';
import { ApprovalStatusItem } from '../components';

interface ReportsMobileProps {
  requestsStatuses: RequestsStatusesResponse['requestsByStatuses'];
  handleViewAll: () => void;
}

const ReportsMobile: React.FC<ReportsMobileProps> = ({
  requestsStatuses,
  handleViewAll,
}) => {
  const dataChart = useMemo(() => {
    return [
      requestsStatuses?.PENDING,
      requestsStatuses?.OPEN,
      requestsStatuses?.APPROVED,
      requestsStatuses?.REJECTED,
    ];
  }, [requestsStatuses]);

  return (
    <>
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>Reports</div>
        <div className={commonStyle.link} onClick={handleViewAll}>
          <ChevroneIcon className={commonStyle.chevrone} />
        </div>
      </div>
      <div>
        <AwesomeSlider
          organicArrows={false}
          bullets
          mobileTouch
          className={classNames(
            commonStyle.mobileSlider,
            styles.mobileSliderReports
          )}
        >
          <div className={styles.approvalsStatus}>
            <div className={styles.captionWidget}>Approvals Status</div>
            <div className={styles.wrapper}>
              <div className={styles.chartWrapper}>
                <DoughnutChart statusesData={dataChart} />
              </div>
              <div className={styles.statuses}>
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.PENDING}
                  statusText="PENDING"
                />
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.OPEN}
                  statusText="OPEN"
                />
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.APPROVED}
                  statusText="APPROVED"
                />
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.REJECTED}
                  statusText="DECLINED"
                />
              </div>
            </div>
          </div>
          {/* <div className={styles.projects}>
            <img
              className={commonStyle.mockImage}
              src={ProjectMock}
              alt="Project information"
            />
          </div> */}
        </AwesomeSlider>
      </div>
    </>
  );
};

export default ReportsMobile;
